export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark',
};
